export default function Price({ p, className = "", testId }) {
  const eff = Number(p.effective_price ?? p.price);
  if (p.on_sale) {
    return (
      <span className={`inline-flex items-baseline gap-2 ${className}`} data-testid={testId}>
        <span className="font-mono-data font-black text-red-600">${eff.toFixed(2)}</span>
        <s className="text-sm text-zinc-400 font-bold" data-testid={testId ? `${testId}-original` : undefined}>${Number(p.original_price ?? p.price).toFixed(2)}</s>
      </span>
    );
  }
  return <span className={`font-mono-data font-black text-[#0C2E2B] ${className}`} data-testid={testId}>${eff % 1 ? eff.toFixed(2) : eff}</span>;
}

export function saleCountdown(p) {
  if (!p?.on_sale || !p.sale_ends_at) return null;
  const today = new Date().toLocaleDateString("en-CA", { timeZone: "America/Chicago" });
  const days = Math.round((new Date(p.sale_ends_at + "T00:00:00") - new Date(today + "T00:00:00")) / 86400000);
  if (days < 0) return null;
  if (days === 0) return "Sale ends today";
  if (days === 1) return "Sale ends tomorrow";
  if (days <= 14) return `Sale ends in ${days} days`;
  return `Sale through ${new Date(p.sale_ends_at + "T00:00:00").toLocaleDateString([], { month: "short", day: "numeric" })}`;
}
